import { Flex, Typography } from '@banhala/ui-kit';
import { useOpenDeeplink } from 'shared/src/hooks';
import { AI_FITTING_ROOMS_ZZIM_DEEPLINK } from '../constants/aiFittingRoomsZzim';
import { useLogClickAiFitting } from '../hooks/useLogClickAiFitting';

/**
 * iOS `AIStudioFittingView` (`AIFittingType.likedProduct`) 대응.
 * 카테고리 필터 row와 카운트 row 사이에 노출.
 */
export const AiFittingButton = () => {
  const { openDeeplink } = useOpenDeeplink();
  const logClick = useLogClickAiFitting();

  const handlePress = () => {
    logClick();
    openDeeplink(AI_FITTING_ROOMS_ZZIM_DEEPLINK);
  };

  return (
    <Flex
      padding={{ horizontal: 16, vertical: 4 }}
      backgroundColor={'bg_primary'}
    >
      <Flex.Row
        height={36}
        alignItems={'center'}
        justifyContent={'center'}
        gap={4}
        borderWidth={1}
        borderColor={'border_secondary'}
        borderRadius={4}
        onPress={handlePress}
      >
        <Typography type={'subtitle4'} color={'content_primary'}>
          AI로 찜해둔 상품 바로입기
        </Typography>
        <Flex
          backgroundColor={'pink5'}
          borderRadius={2}
          padding={{ vertical: 1, horizontal: 2 }}
        >
          <Typography type={'subtitle7'} color={'content_pink_primary'}>
            NEW
          </Typography>
        </Flex>
      </Flex.Row>
    </Flex>
  );
};
